// extracted by mini-css-extract-plugin
export default {"meetTeam":"MeetTeam_meetTeam__7B5eW"};